import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, className = "" }) => (
  <motion.div
    initial={{ opacity: 0, y: 32 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-80px" }}
    transition={{ duration: 0.9, delay, ease: [0.16, 1, 0.3, 1] }}
    className={className}
  >
    {children}
  </motion.div>
);

export const SectionHead = ({ label, title, sub, testId }) => (
  <Reveal>
    {label && <p className="gc-eyebrow">{label}</p>}
    <h2 data-testid={testId} className="mt-4 font-serif text-3xl sm:text-5xl tracking-tight leading-[1.1] text-ivory">{title}</h2>
    {sub && <p className="mt-5 max-w-2xl text-ash font-light leading-relaxed">{sub}</p>}
    <div className="gc-gold-line mt-8 w-24 !bg-none bg-gold/60" />
  </Reveal>
);
